import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PageRequest } from '@models/models';
import { PaginationService } from '@services/pagination/pagination.service';

@Component({
	selector: 'simple-pagination',
	template: require('./simple-pagination.html')
})
export class SimplePaginationComponent implements OnInit {
	@Input() totalPages: number;
	@Input() totalItems: number;
	@Input() pageRequest: PageRequest;
	@Output() changePageTrigger: EventEmitter<PageRequest> = new EventEmitter();

	constructor(private paginationService: PaginationService) {}

	ngOnInit() {}

	getCurrentPage(): number {
		return this.pageRequest.paging.pageNumber;
	}

	changePage(direction: number): void {
		const newPageNumber = this.pageRequest.paging.pageNumber + direction;
		const newPageRequest = this.paginationService.changePage(
			this.pageRequest,
			this.totalItems,
			newPageNumber
		);

		if (newPageRequest) {
			this.changePageTrigger.emit(newPageRequest);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/buttons/simple-pagination/simple-pagination.ts